import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg12, newEntidadesFinancierasSchema } from '@/shared';
import { useCreateEntidadesFinancieras, useUpdateEntidadesFinancieras } from '@/shared/actions/erp';
import {
  CustomNumberTextField,
  CustomTextField,
  ModelStateSelect,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { EntidadesFinancieras } from '@/shared/interfaces';


const returnUrlEntidades = '/parametrizacion/entidades-financieras';

export interface SaveEntidadesFinancierasInterface {
  titlePage: string;
  editEntidadesFinancieras?: EntidadesFinancieras;
}

type SaveFormData = {
  nombre: string;
  codigo_auxiliar: string;
  numero_referencia: string;
  estado?: boolean;
};

const SaveEntidadesFinancieras: React.FC<SaveEntidadesFinancierasInterface> = ({ titlePage, editEntidadesFinancieras }) => {

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createEntidadesFinancierasMutation = useCreateEntidadesFinancieras({ navigate, returnUrl: returnUrlEntidades });
  const updateEntidadesFinancierasMutation = useUpdateEntidadesFinancieras({ navigate, returnUrl: returnUrlEntidades });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newEntidadesFinancierasSchema),
  });
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editEntidadesFinancieras?.id_entidad_financiera) {
      return updateEntidadesFinancierasMutation.mutate({
        id: editEntidadesFinancieras.id_entidad_financiera,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createEntidadesFinancierasMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editEntidadesFinancieras) {
      setShrink(true);
      reset({
        ...editEntidadesFinancieras,
        estado: !!editEntidadesFinancieras.estado ? '1' : '0',
      } as any);
    }
  }, [editEntidadesFinancieras]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlEntidades);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        control={control}
        name="nombre"
        defaultValue={form.getValues().nombre}
        size={gridSizeMdLg12}
        label={'Nombre'}
        error={errors.nombre}
        helperText={errors.nombre?.message} />

      <CustomTextField
        control={control}
        name="codigo_auxiliar"
        type='none'
        defaultValue={form.getValues().codigo_auxiliar}
        size={gridSizeMdLg12}
        label={'Codigo Entidad Financiera'}
        error={errors.codigo_auxiliar}
        helperText={errors.codigo_auxiliar?.message} />

      <CustomNumberTextField
        label="Numero referencia"
        name="numero_referencia"
        //register={register('numero_referencia')}
        error={errors.numero_referencia}
        control={form.control}
        helperText={errors.numero_referencia?.message}
        shrink={shrink}
        defaultValue={form.getValues().numero_referencia || " "}
      />
      {/* ====== state ====== */}
      <ModelStateSelect
        defaultValue={form.getValues().estado || ''}
        register={register('estado')}
        error={errors.estado}
        helperText={errors.estado?.message}
      />
    </SingleFormBoxScene>
  );
};

export default SaveEntidadesFinancieras;
